module.exports = __webpack_public_path__ + "img/icon-moonpay-white.a499fabf.svg";